import { SelectInput } from "components/FormControls/Select/Select";
import { rewardFulfillmentStatus } from "constants/general";
import { useMessage } from "hooks/intl";
import { SelectedFilter } from "types/filters";
import { useStyles } from "../../styles";

interface Props {
  index: number;
  size: "small" | "medium" | "inline";
  onChange?: () => void;
  filter: SelectedFilter;
}

export const RewardFullfilmentStatus = ({
  index,
  size,
  onChange,
  filter,
}: Props) => {
  const { message } = useMessage();
  const classes = useStyles();
  const isInlineType = size === "inline";

  return (
    <SelectInput
      name={`filters.${index}.value`}
      items={rewardFulfillmentStatus.map((item) => ({
        id: item,
        label: message({ id: item }),
      }))}
      size={isInlineType ? "small" : size}
      placeholder={message({ id: "value" })}
      className={isInlineType ? classes.inlineValue : ""}
      adjustWidthToValue={isInlineType}
      onChange={onChange}
      multiple={filter.condition === "in"}
      validateOnChange
      data-test-id="filter-value"
    />
  );
};
